import {EventBus} from "../../../../common/ts/events/EventBus";
import dom from "../../../../common/ts/core/dom";
import {PageWithDfpRightBlockScrolledEvent} from "./events";
import eventHandlers from "./eventHandlers";

let eventBus: EventBus;

function init({
    topBoundaryElement,
    topSiblingElement,
    bottomBoundaryElement,
    navbarElement,
    ev = EventBus.getInstance(),
}: {
    topBoundaryElement: Element|null,
    topSiblingElement: Element|null,
    bottomBoundaryElement: Element|null,
    navbarElement: Element|null,
    ev?: any,
}) {
    eventBus = ev;
    eventHandlers.init();
    const secondDfp = dom.select('.js-dfp-right-block__bottom');
    const topSiblingSpacing = 16;
    const secondDfpSpacings = 36;

    window.addEventListener("scroll", () => {
        if (topBoundaryElement && topSiblingElement && secondDfp && bottomBoundaryElement) {
            eventBus.emit(new PageWithDfpRightBlockScrolledEvent({
                topSiblingElement: topSiblingElement.getBoundingClientRect().bottom,
                topSiblingSpacing: topSiblingSpacing,
                secondDfpBottom: secondDfp.getBoundingClientRect().bottom,
                secondDfpSpacing: secondDfpSpacings,
                topBoundaryElementBottom: topBoundaryElement.getBoundingClientRect().bottom,
                bottomBoundaryElementBottom: bottomBoundaryElement.getBoundingClientRect().bottom,
                windowHeight: window.innerHeight,
                navbarElementHeight: navbarElement ? navbarElement.getBoundingClientRect().height : 0,
            }));
        }
    });
}

export default {
    init,
}